module.exports = __webpack_public_path__ + "components/country-flag/static/pe-87dcb23a10ae1b3467a5a67b2fc4931a.svg";